<template>
  <div :id="name" class="flex flex-col border-t last:border-b border-gray-200">
    <header
      class="p-3 flex items-center"
      :class="!isExpanded ? 'hover:bg-select cursor-pointer' : ''"
      @click.stop="setExpanded(true)"
    >
      <div
        class="w-12 flex-none cursor-pointer"
        :class="isExpanded ? 'text-action' : ''"
        @click.stop="toggleForm"
      >
        <div
          class="w-5 h-5 rounded-full border flex items-center justify-center"
          :class="
            isExpanded
              ? 'border-action'
              : 'border-gray-300 hover:bg-menu-hover hover:border-gray-800'
          "
        >
          <span class="text-xs">
            <font-awesome-icon
              icon="check"
              v-if="isExpanded"
            ></font-awesome-icon>
          </span>
        </div>
      </div>
      <div class="">
        <div
          class="font-bold cursor-pointer"
          v-html="title"
          @click.stop="toggleForm"
        ></div>
        <p v-html="subtitle" class="text-justify"></p>
      </div>
    </header>
    <form
      class="form form-table pr-3"
      v-show="isExpanded"
      @submit.prevent="submitForm"
    >
      <label class="form-field" v-if="fields['usual_software']">
        <span class="label">{{ fields["usual_software"].label }}</span>
        <div class="control">
          <select v-model="form.usual_software">
            <option disabled value="">-----</option>
            <option v-for="(text, i) in softwareOptions" :key="i" :value="i">
              {{ text }}
            </option>
          </select>
          <input
            type="text"
            size="40"
            :placeholder="fields.software_version.placeholder"
            maxlength="120"
            v-model="form.software_version"
          />
        </div>
      </label>
      <SpecificField
        v-for="(field, id) in fields"
        :key="id"
        :id="id"
        :fields="fields"
        v-model="form[id]"
      />
      <label class="form-field">
        <span class="label">{{ common.subject.label }}*</span>
        <input
          class="control"
          type="text"
          size="40"
          :placeholder="common.subject.placeholder"
          maxlength="120"
          required
          v-model="form.subject"
        />
      </label>
      <label class="form-field">
        <span class="label">{{ common.body.label }}*</span>
        <textarea
          class="control"
          cols="40"
          rows="10"
          required
          v-model="form.body"
        ></textarea>
      </label>
      <label class="form-field">
        <span class="label">{{ common.attachment.label }}</span>
        <div class="control flex-col">
          <input type="file" @change="updateAttachement" />
          <span class="help">{{ common.attachment.max_size }}</span>
        </div>
      </label>

      <label class="form-field">
        <span class="label">{{ common.firstname.label }}</span>
        <input type="text" class="control" v-model="form.firstname" />
      </label>
      <label class="form-field">
        <span class="label">{{ common.lastname.label }}</span>
        <input type="text" class="control" v-model="form.lastname" />
      </label>
      <label class="form-field">
        <span class="label">{{ common.email.label }}*</span>
        <input type="email" class="control" v-model="form.email" required />
      </label>
      <div class="form-field">
        <label for="phone_number" class="label">{{ common.phone.label }}</label>
        <div class="control flex-col">
          <div
            class="phone-input flex item-center justify-start w-full border border-gray-200 bg-white rounded"
          >
            <div
              class="bg-action text-black flex items-center rounded-left border border-action rounded-r-none rounded w-24"
            >
              <label for="phone_code" class="px-3 text-center">+</label>
              <input
                class="code rounded-0 border-none bg-action w-16"
                placeholder=""
                id="phone_code"
                type="number"
                name="phone_code"
                v-model="form.phone_code"
              />
            </div>
            <input
              class="number code rounded-0 border-none"
              pattern="^[0-9\. \(\)_+-]+$"
              placeholder=""
              id="phone_number"
              type="text"
              name="phone_number"
              v-model="form.phone_number"
            />
          </div>
          <span class="help">{{ common.phone.hint }}</span>
        </div>
      </div>
      <alert
        v-if="success"
        :message="success"
        level="success"
        class="p-2"
      ></alert>
      <div class="py-5 flex justify-center" v-else>
        <button class="button action px-2 py-1" type="submit">
          <template v-if="!processing">{{ common.send }}</template>
          <font-awesome-icon icon="spinner" spin v-else />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

import Alert from "../Design/Alert";
import SpecificField from "./_SpecificField";

export default {
  props: [
    "name",
    "title",
    "subtitle",
    "isExpanded",
    "fields",
    "common",
    "softwareOptions",
  ],
  components: { Alert, SpecificField },
  data() {
    const account = this.$store.state.account;
    return {
      processing: false,
      success: false,
      form: {
        type: this.name,
        subject: "",
        body: "",
        attachment: null,
        firstname: account.contact.firstname,
        lastname: account.contact.lastname,
        email: account.user.email,
        phone_code: account.contact.phone.code,
        phone_number: account.contact.phone.number,

        usual_software: this.$route.query.usual_software || "",
        software_version: this.$route.query.software_version || "",
        ranchecker_version: "",
        project_step: "",
        project_ids: this.$route.query.project_ids || "",
        credit_type: this.$route.query.credit_type || "",
        invoice_ids: this.$route.query.invoice_ids || "",
        quote_type: "",
        faulty_software: "",
        version: "",
      },
    };
  },
  methods: {
    setExpanded(v) {
      this.$emit("form-selected", v ? this.name : "");
    },
    toggleForm() {
      this.setExpanded(!this.isExpanded);
    },
    updateAttachement(e) {
      if (!e.target.files.length) {
        e.target.value = null;
        this.form.attachment = null;
        return;
      }

      const file = e.target.files[0];
      if (file.size > 6 * 1000 * 1000) {
        alert("⚠️ " + this.common.attachment.max_size + " ⚠️");
        e.target.value = null;
        this.form.attachment = null;
        return;
      }

      this.form.attachment = e.target.files[0];
    },

    submitForm() {
      if (this.processing) {
        return;
      }
      this.processing = true;

      const formData = new FormData();
      Object.keys(this.form).forEach((k) => {
        if (this.form[k] === null) {
          return;
        }
        formData.append(k, this.form[k]);
      });

      axios
        .post(this.common.route, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          this.success = data.message;
        })
        .catch(handleAxiosError)
        .then(() => {
          this.processing = false;
        });
    },
  },
};
</script>
